import { AxiosInstance } from 'axios';
import { Dictionary } from 'lodash';
import {
    OrderStatus,
    OrderStatusCounters,
    OrderStatusSection,
    OrderStatusTable,
} from 'models/api/orderStatus';
import RolesQueryInfo from 'models/api/rolesQueryInfo';
import ResTable from 'models/api/table';
import { OrderStatusOrderCountFilter } from '../models/api/order';
import { DropDown, Filter } from '@finbeat/react-toolkit';

export const getOrderStatuses = async (
    axios: AxiosInstance,
    notUsed: boolean | null,
    params: Filter = {}
) => {
    const { data } = await axios.get<ResTable<OrderStatusTable>>(`/orderstatus`, {
        params: { ...params, notUsed },
    });
    data.data.map((x) => (x.id = x.code));
    return data;
};

export const getOrderStatusesSelectList = async (
    axios: AxiosInstance,
    notUsed: boolean | null,
    params: Filter = {}
) => {
    const { data } = await axios.get<DropDown[]>(`/orderstatus/selectList`, {
        params: { ...params, notUsed },
    });
    return data;
};

export const getOrderStatus = async (axios: AxiosInstance, code: string) => {
    const { data } = await axios.get<OrderStatus>(`/orderstatus/${code}`);
    return data;
};

export const changeOrderStatusItem = async (axios: AxiosInstance, item: OrderStatus) => {
    return await axios.post(`/orderstatus/${item.code}`, item);
};

export const getOrderStatusRolesList = async (axios: AxiosInstance) => {
    return await axios.get<RolesQueryInfo[]>(`/orderstatus/GetOrderStatusRolesList`);
};

export const getOrderStatusStatuses = async (axios: AxiosInstance) => {
    const { data } = await axios.get<OrderStatusCounters[]>(`/orderstatus/statuses`);
    return data;
};

export const getOrderStatusCounters = async (
    axios: AxiosInstance,
    orderStatusOrderCountFilter: OrderStatusOrderCountFilter
) => {
    const { data } = await axios.get<Dictionary<number>>(`/orderstatus/counters`, {
        params: {
            ...orderStatusOrderCountFilter,
        },
    });
    return data;
};

export const getOrderStatusSectionsList = async (axios: AxiosInstance) => {
    return await axios.get<OrderStatusSection[]>(`/orderstatus/sections`);
};
